import { get } from 'lodash';

import { AppState } from 'Interfaces/Interfaces';

const root = (state: AppState) => get(state, 'addStudentModalState');

export const getOpen = (state: AppState) => get(root(state), 'open', false);
export const getError = (state: AppState) => get(root(state), 'error', false);
